module.exports = __webpack_public_path__ + "img/1440.a5ec8ef6.jpg";